// import CheckBox from "../component/check-box/CheckBox";
// import DropDown from "../component/dropdown/DropDown";
// import FilledButton from "../component/filled-button/FilledButton";
import Counter from "../component/counter/Counter";
// import DropDown from "../component/dropdown/DropDown";
// import FilledButton from "../component/filled-button/FilledButton";
import {
  Check,
  CloseBlackIcon,
  Cross,
  DropdownIcon2,
  Error,
  Info,
  LeftArrow,
  Tick,
  Warning,
} from "../component/svg-components";
import Swipper from "../component/swipper/Swipper";
// import ToggleSwitch from "../component/toggle-switch/ToggleSwitch";

export const barChartData = [
  {
    name: "SA Equity (PPM)",
    a: 3950,
    R: "R6,1m",
  },
  {
    name: "TFSA (PPM)",
    b: 3500,
    R: "R2,5m",
  },
  {
    name: "Allan Gray Equity",
    c: 3900,
    R: "R15,4m",
  },
  {
    name: "Allan Gray (RA)",
    d: 4200,
    R: "R26,1m",
  },
  {
    name: "Allan Gray (LA)",
    e: 4000,
    R: "R20,9m",
  },
  {
    name: "Allan Gray TFSA",
    f: 3800,
    R: "R3,1m",
  },
  {
    name: "Walt Cap Global Fund",
    g: 4300,
    R: "R96,8",
    m: "%5,7m",
  },
  {
    name: "Offshore Private Equity",
    h: 4300,
    R: "5%",
  },
];

export const monthlyFeesSAData = [
  {
    title: "Net brokerage",
    fees: "85,599",
  },
  {
    title: "Management fees",
    fees: "41,539",
  },
  {
    title: "Performance fees",
    fees: "126,912",
  },
  {
    title: "Admin fees",
    fees: "19,001",
  },
  {
    title: "JSET interest turn",
    fees: "21,295",
  },
];

export const monthlyFeesCookData = [
  {
    title: "Management fees",
    fees: "85,599",
  },
  {
    title: "Performance fees",
    fees: "41,539",
  },
  {
    title: "Annual structure fees",
    fees: "126,912",
  },
  {
    title: "New structure setup  fees",
    fees: "19,001",
  },
  {
    title: "Other fees/trading income",
    fees: "21,295",
  },
];
export const clientListData = [
  {
    letter: "A",
    name: "Allan Gray Equity",
    amount: "15,141,559",
    number: "56",
  },
  {
    letter: "A",
    name: "Allan Gray (RA)",
    amount: "15,451,559",
    number: "31",
  },
  {
    letter: "A",
    name: "Allan Gray (LA)",
    amount: "15,451,559",
    number: "15",
  },
  {
    letter: "A",
    name: "Allan Gray TFSA",
    amount: "15,451,559",
    number: "231",
  },
  {
    letter: "A",
    name: "Cook Island Trusts",
    amount: "15,451,559",
    number: "18",
  },
  {
    letter: "A",
    name: "Cook Island LLCs",
    amount: "15,451,559",
    number: "2",
  },
];

export const tabledata = [
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: true,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: true,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: false,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: true,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: true,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: false,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: false,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: true,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: false,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: true,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: true,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: true,
  },
  {
    cross: <Cross fillColor="#0868AA" />,
    name: "USDZAR",
    last: "15.19213",
    netchg: "0.06273",
    perchg: "0.41 %",
    status: true,
  },
];

export const GraphData = [
  {
    value: "0.05",
    uv: 4000,
    pv: 2400,
    amt: 2400,
    "%change": 124,
  },
  {
    value: "12:00",
    uv: 3000,
    pv: 1398,
    amt: 2210,
    "%change": 221,
  },
  {
    value: "15:00",
    uv: 2000,
    pv: 8800,
    amt: 2290,
    "%change": 221,
  },
  {
    value: "10",
    uv: 2780,
    pv: 3908,
    amt: 2000,
    "%change": 217,
  },
  {
    value: "12:00",
    uv: 1890,
    pv: 4800,
    amt: 2181,
    "%change": 967,
  },
  {
    value: "15:00",
    uv: 2390,
    pv: 3800,
    amt: 2500,
    "%change": 467,
  },
  {
    value: "11",
    uv: 3490,
    pv: 4300,
    amt: 2100,
    "%change": 712,
  },
  {
    value: "12:00",
    uv: 2323,
    pv: 1212,
    amt: 2435,
    "%change": 343,
  },
  {
    value: "15:00",
    uv: 2111,
    pv: 4565,
    amt: 6768,
    "%change": 154,
  },
  {
    value: "14",
    uv: 3454,
    pv: 2335,
    amt: 2100,
    "%change": 143,
  },
  {
    value: "12:00",
    uv: 4567,
    pv: 2323,
    amt: 9087,
    "%change": 323,
  },
  {
    value: "15:00",
    uv: 4567,
    pv: 2323,
    amt: 9087,
    "%change": 323,
  },
];

export const login =
  "Disclaimer: It is important to know past performance is not necessarily a guide to future performance. Daily portfolio and fund values are not guaranteed. While every effort has been made to ensure the accuracy and completeness of the information, opinions and recommendations contained in this online forum, they must be construed solely as statements of opinion and not of fact. No warranty, expressed or implied, as to the completeness, merchantability or fitness for any particular purpose of any such recommendation or information is given or made by Walt Capital Management (Pty) Ltd or any of their subsidiaries (“WCM”) in any form or manner whatsoever. WCM assumes no fiduciary responsibility or liability for any consequences, financial or otherwise arising from the implementation of the investment. WCM shall not be liable to the investor in any manner whatsoever for any loss or damage suffered by the investor arising in or out of the investment or in any other manner whatsoever and the investor hereby indemnifies WCM in respect of any such loss or damage by logging into and perusing the information on this online forum. While this document has been prepared in good faith, it is nonetheless recommended that independent professional legal, tax, accounting and other appropriate advice should be taken so as to consider the document in the light of the recipient’s particulars and unique circumstances. In some examples some back-testing and pro forma performance figures are shown for pure illustration purposes only and are based on information that WCM believes is fair. However, past performance is not a guarantee of future results. WCM assumes no liability for any errors or omissions contained herein. This document and online forum is subject to copyright and may not be produced in whole or in part without permission of Walt Capital Management (Pty) Ltd Walt Capital Management is an authorised category 2 financial services provider and is registered with the FSCA. Reg. number: 50218";
// export const portfolioDropdownData = [
//   {
//     title: "JSE Equity Portfolio",
//     navigate: "portfolios/jseequityportfolio",
//   },
//   {
//     title: "SAFEX Portfolio",
//     navigate: "portfolios/safexportfolio",
//   },
//   {
//     title: "JSE Tax Free Account(TFSA)",
//     navigate: "portfolios/jsetaxfreeaccount",
//   },
//   {
//     title: "Offshore Trade StationEquity",
//     navigate: "portfolios/offshoretradestationequity",
//   },
//   {
//     title: "Offshore Interactive Brokers Equity",
//     navigate: "portfolios/offshoreinteractivebrokerequity",
//   },
//   {
//     title: "Allan Gray - Equity",
//     navigate: "portfolios/allangrayequity",
//   },
//   {
//     title: "Allan Gray - RA",
//     navigate: "portfolios/allangrayra",
//   },
//   {
//     title: "Allan Gray - LA",
//     navigate: "portfolios/allangrayla",
//   },
//   {
//     title: "Allan Gray - TFSA",
//     navigate: "portfolios/allangraytfsa",
//   },
// ];

export const birthdayReportTableHead = [
  "",
  "Name",
  "Age",
  "Birthday Date",
  "Action",
];

export const birthdayReportData = [
  {
    id: 1,
    initial: "J",
    name: "John Snow",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 2,
    initial: "A",
    name: "Allen Grew",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 3,
    initial: "J",
    name: "John Snow",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 4,
    initial: "A",
    name: "Allen Grew",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 5,
    initial: "J",
    name: "John Snow",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 6,
    initial: "A",
    name: "Allen Grew",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 7,
    initial: "J",
    name: "John Snow",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 8,
    initial: "A",
    name: "Allen Grew",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 9,
    initial: "J",
    name: "John Snow",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 10,
    initial: "J",
    name: "Allen Grew",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 11,
    initial: "J",
    name: "John Snow",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 12,
    initial: "J",
    name: "Allen Grew",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 13,
    initial: "J",
    name: "John Snow",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 14,
    initial: "A",
    name: "Allen Grew",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 15,
    initial: "J",
    name: "John Snow",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
  {
    id: 16,
    initial: "A",
    name: "Allen Grew",
    age: "Turns 45yrs",
    birthdayDate: "21 September 1971",
  },
];

export const TaskMeetingTableHead = [
  <input type="checkbox" />,
  "Task/Meeting",
  "Date",
  "Time",
  "Action",
];

export const TaskMeetingData = [
  {
    initial: <input type="checkbox" />,
    name: "Zoom Meeting - with Trade Station",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Phone jo soap Re - his TFSA",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Zoom Meeting - with Trade Station",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Phone jo soap Re - his TFSA",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Zoom Meeting - with Trade Station",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Phone jo soap Re - his TFSA",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Zoom Meeting - with Trade Station",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Phone jo soap Re - his TFSA",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Zoom Meeting - with Trade Station",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Phone jo soap Re - his TFSA",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Zoom Meeting - with Trade Station",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
  {
    initial: <input type="checkbox" />,
    name: "Phone jo soap Re - his TFSA",
    age: "12 march 2022",
    birthdayDate: "14h00",
  },
];

export const InvestmentData = [
  {
    type: "Priced in ZAR",
    price: "R 4,753,560",
  },
  {
    type: "Priced in USD",
    price: "USD 353,560",
  },
  {
    type: "Priced in gold",
    price: "1,560 grams (47.5 Oz)",
  },
];

export const accountData = [
  {
    amount: "$75,957",
    accountname: "Walt Capital Global Fund ",
  },
  {
    amount: "R201,759",
    accountname: "Tax Free Investment Account (PPM)",
  },

  // {
  //   amount: "R659,998",
  //   accountname: "JSE Equity SA Share Portfolio (PPM)",
  //   navigate: "jseequity",
  // },
  // {
  //   amount: "R3,351,007",
  //   accountname: "Allan Gray RA",
  //   navigate: "jseequity",
  // },
];

export const clientsTableHead = [
  // <input type="checkbox" />,
  "Account No.",
  "Name",
  "Email",
  "Phone Number",
  "Birthday",
  "Join Date",
  // "Investment Value",
];
export const clientTableData = [
  {
    id: 1,
    // initial: <input type="checkbox" />,
    account_no: "115489",
    name: "Drago Mijatović",
    email: "DragoMijatovic@rhyta.com",
    phone: "083 819 6231",
    birthday: "January 19, 2001",
    joindate: "02/05/2020",
    investment_value: "R 308851.50",
  },
  {
    id: 2,
    // initial: <input type="checkbox" />,
    account_no: "458462",
    name: "Rato Barić",
    email: "RatoBaric@armyspy.com",
    phone: "083 819 6231",
    birthday: "May 1, 1970",
    joindate: "06/12/2021 ",
    investment_value: "R 10841.50",
  },
  {
    id: 3,
    // initial: <input type="checkbox" />,
    account_no: "265484",
    name: "Vid Tadić",
    email: "VidTadic@dayrep.com",
    phone: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "06/08/2015",
    investment_value: "R 567851.50",
  },
  {
    id: 4,
    // initial: <input type="checkbox" />,
    account_no: "236548",
    name: "Romana Ivanec",
    email: "RomanaIvanec@xv.com",
    phone: "083 819 6231",
    birthday: "May 29, 1988",
    joindate: "06/08/2015",
    investment_value: "R -258854",
  },
  {
    id: 5,
    // initial: <input type="checkbox" />,
    account_no: "123548",
    name: "Milka Čeh",
    email: "MilkaCeh@jourrapide.com",
    phone: "083 819 6231",
    birthday: "March 26, 1943",
    joindate: "02/01/2020",
    investment_value: "R 108487.36",
  },
  {
    id: 6,
    // initial: <input type="checkbox" />,
    account_no: "653548",
    name: "Zrinko Brkić",
    email: "ZrinkoBrkic@dayrep.com",
    phone: "083 819 6231",
    birthday: "August 17, 1974",
    joindate: "10/09/2020",
    investment_value: "R -125651.755",
  },
  {
    id: 7,
    // initial: <input type="checkbox" />,
    account_no: "564852",
    name: "Kristian Milić",
    email: "KristianMilic@dayrep.com",
    phone: "083 819 6231",
    birthday: "December 18, 1953",
    joindate: "18/05/2017",
    investment_value: "R 325671.50",
  },
  {
    id: 8,
    // initial: <input type="checkbox" />,
    account_no: "125489",
    name: "Smiljana Brajković",
    email: "DSmiljanaBraj@dayrep.com",
    phone: "083 819 6231",
    birthday: "February 12, 1970",
    joindate: "12/08/2016",
    investment_value: "R 2568551.50",
  },
  {
    id: 9,
    // initial: <input type="checkbox" />,
    account_no: "985421",
    name: "Dario Herceg",
    email: "DarioHerceg@dayrep.com",
    phone: "083 819 6231",
    birthday: "November 18, 1955",
    joindate: "22/05/2010",
    investment_value: "R -61851.50",
  },
  {
    id: 10,
    // initial: <input type="checkbox" />,
    account_no: "456841",
    name: "Zorislav Jurišić",
    email: "ZorislavJurisic@xv.com",
    phone: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "26/7/2012",
    investment_value: "R 21891.10",
  },
  {
    id: 11,
    // initial: <input type="checkbox" />,
    account_no: "115489",
    name: "Kristian Milić",
    email: "KristianMilic@dayrep.com",
    phone: "083 819 6231",
    birthday: "December 18, 1953",
    joindate: "18/05/2017",
    investment_value: "R 308851.50",
  },
  {
    id: 12,
    // initial: <input type="checkbox" />,
    account_no: "458462",
    name: "Smiljana Brajković",
    email: "DSmiljanaBraj@dayrep.com",
    phone: "083 819 6231",
    birthday: "February 12, 1970",
    joindate: "12/08/2016",
    investment_value: "R 10841.50",
  },
  {
    id: 13,
    // initial: <input type="checkbox" />,
    account_no: "265484",
    name: "Dario Herceg",
    email: "DarioHerceg@dayrep.com",
    phone: "083 819 6231",
    birthday: "November 18, 1955",
    joindate: "22/05/2010",
    investment_value: "R 567851.50",
  },
];
export const annualBalanceData = [
  {
    id: "AGLP 123456",
    balance: "R 1,153,123",
  },
  {
    id: "AGRA 1259",
    balance: "R 1,821,125",
  },
  {
    id: "AGLA 89654",
    balance: "R 306,001",
  },
  {
    id: "AGTF 4565",
    balance: "R 70,758",
  },
];

export const CapitalGainGraphData = [
  {
    value: "2015/7/1",
    uv: 4000,
    pv: 2400,
    amt: 2400,
    yAxis: "R1.25",
  },
  {
    value: "2016/1/1",
    uv: 3000,
    pv: 1398,
    amt: 2210,
    yAxis: "R1.25",
  },
  {
    value: "2016/7/1",
    uv: 2000,
    pv: 8800,
    amt: 2290,
    yAxis: "R1.25",
  },
  {
    value: "2017/1/1",
    uv: 2780,
    pv: 3908,
    amt: 2000,
    yAxis: "R1.25",
  },
  {
    value: "2017/7/1",
    uv: 1890,
    pv: 4800,
    amt: 2181,
    yAxis: "R1.25",
  },
  {
    value: "2018/1/1",
    uv: 2390,
    pv: 3800,
    amt: 2500,
    yAxis: "R1.25",
  },
  {
    value: "2018/7/1",
    uv: 3490,
    pv: 4300,
    amt: 2100,
    yAxis: "R1.25",
  },
  {
    value: "2019/1/1",
    uv: 2323,
    pv: 1212,
    amt: 2435,
    yAxis: "R1.25",
  },
];

export const ClientTransactionTableHeading = [
  "Aug2017",
  "Sep2017",
  "Oct2017",
  "Nov2017",
  "Dec2017",
  "Jan2018",
  "Feb2018",
  "Mar2018",
  "Apr2018",
  "May2018",
  "June2018",
  "July2018",
];

export const ClientTransactionTableRow = [
  "-0.97%",
  "-2.43%",
  "-0.97%",
  "-2.43%",
  "-2.43%",
  "-0.97%",
  "-2.43%",
  "-0.97%",
  "-2.43%",
  "-0.97%",
  "-2.43%",
  "-0.97%",
];

export const FundSuitsStatsHeading = ["Fund", "Fund Size", "Unit Issued"];

export const FundSuitsStatsRow = ["Fund Suits", "R0.00", "0.00"];

export const ReturnsData = [
  {
    title: "Month To Date",
    value: "0%",
  },
  {
    title: "Since Inception",
    value: "-2.54%",
  },
  {
    title: "Since Inception (Annualized)",
    value: "0.9%",
  },
  {
    title: "12 Month Rolling",
    value: "-12.84%",
  },
  {
    title: "3years Rolling",
    value: "NaN",
  },
  {
    title: "5years Rolling",
    value: "NaN",
  },
];

export const FundStatsData = [
  {
    title: "Inception date",
    value: "1 October 2015",
  },
  {
    title: "Fund size",
    value: "R246,569.63",
  },
  {
    title: "Units issued",
    value: "252,998.40",
  },
  {
    title: "Unit price",
    value: "R0.9746",
  },
];
export const runfeesTableHead = [
  "Fees",
  "Last Run",
  "Last Amount",
  "Next Run Date",
  "Action",
  "Pending Amount",
  "Total",
  "VAT",
  "Total incl VAT",
];
export const runfeesTableData = [
  {
    fees: "Audit fee",
    lastRun: "2020-09-30",
    lastAmount: "50.00",
    pendingAmount: "50.00",
    total: "50.00",
    vat: "50.00",
    totalvat: "50.00",
  },
  {
    fees: "Compliance fee",
    lastRun: "2020-09-30",
    lastAmount: "50.00",
    pendingAmount: "50.00",
    total: "50.00",
    vat: "50.00",
    totalvat: "50.00",
  },
  {
    fees: "Management fee",
    lastRun: "2020-09-30",
    lastAmount: "3,958",
    pendingAmount: "3,958",
    total: "3,958",
    vat: "3,958",
    totalvat: "3,958",
  },
  {
    fees: "Performance fee",
    lastRun: "2020-09-30",
    lastAmount: "7,556",
    pendingAmount: "7,556",
    total: "7,556",
    vat: "7,556",
    totalvat: "7,556",
  },
  {
    fees: "IFA fee",
    lastRun: "2020-09-30",
    lastAmount: "590.54",
    pendingAmount: "590.54",
    total: "590.54",
    vat: "590.54",
    totalvat: "590.54",
  },
];
export const tableData = [
  // {
  //   title: "Stock Account:",
  // },
  {
    title: "Bank:",
  },
  {
    title: "Futures:",
  },
  {
    title: "Stock:",
  },
  // {
  //   title: "Compliance fee:",
  // },
  // {
  //   title: "Audit fee:",
  // },
  // {
  //   title: "Other:",
  // },
];
export const feeData = [
  {
    title: "Audit Fee",
    country: "USD",
    price: "600.0",
  },
  {
    title: "Management fees",
    country: "USD",
    price: "600.0",
  },
  {
    title: "Performance fees",
    country: "USD",
    price: "34,190.6",
  },
  {
    title: "Compliance fees",
    country: "USD",
    price: "101,088.12",
  },
  {
    title: "IFA fees",
    country: "USD",
    price: "3,430.11",
  },
];

export const clientListTableHeader = [
  "",
  "Name",
  "Title",
  "Acc.number",
  "Units",
  "Value",
  "Cost NAV",
  "Current NAV ",
  "Tel.no",
  "Mobile no.",
  "Email",
];

export const ClientListData = [
  {
    // initial: <input type="checkbox" />,

    name: "Snow john",
    title: "Mr.",
    accNumber: "100001",
    units: "1,453,333.1",
    value: "$18,445,125",
    costNav: "$105902",
    currentNav: "$186503",
    telNo: "0212014556",
    mobileNo: "0824541234",
    email: "john@snow.com",
  },
  {
    // initial: <input type="checkbox" />,
    name: "Snow john",
    title: "Mr.",
    accNumber: "100001",
    units: "1,453,333.1",
    value: "$18,445,125",
    costNav: "$105902",
    currentNav: "$186503",
    telNo: "0212014556",
    mobileNo: "0824541234",
    email: "john@snow.com",
  },
  {
    // initial: <input type="checkbox" />,
    name: "Snow john",
    title: "Mr.",
    accNumber: "100001",
    units: "1,453,333.1",
    value: "$18,445,125",
    costNav: "$105902",
    currentNav: "$186503",
    telNo: "0212014556",
    mobileNo: "0824541234",
    email: "john@snow.com",
  },
  {
    // initial: <input type="checkbox" />,
    name: "Snow john",
    title: "Mr.",
    accNumber: "100001",
    units: "1,453,333.1",
    value: "$18,445,125",
    costNav: "$105902",
    currentNav: "$186503",
    telNo: "0212014556",
    mobileNo: "0824541234",
    email: "john@snow.com",
  },
  {
    // initial: <input type="checkbox" />,
    name: "Snow john",
    title: "Mr.",
    accNumber: "100001",
    units: "1,453,333.1",
    value: "$18,445,125",
    costNav: "$105902",
    currentNav: "$186503",
    telNo: "0212014556",
    mobileNo: "0824541234",
    email: "john@snow.com",
  },
  {
    // initial: <input type="checkbox" />,
    name: "Snow john",
    title: "Mr.",
    accNumber: "100001",
    units: "1,453,333.1",
    value: "$18,445,125",
    costNav: "$105902",
    currentNav: "$186503",
    telNo: "0212014556",
    mobileNo: "0824541234",
    email: "john@snow.com",
  },
  {
    // initial: <input type="checkbox" />,
    name: "Snow john",
    title: "Mr.",
    accNumber: "100001",
    units: "1,453,333.1",
    value: "$18,445,125",
    costNav: "$105902",
    currentNav: "$186503",
    telNo: "0212014556",
    mobileNo: "0824541234",
    email: "john@snow.com",
  },
];
export const clientListSumData = {
  name: " ",
  title: " ",
  title: "",
  total: "Total :",
  units_total: "1,663,533.58",
  value_total: "$11,000,028 ",
  costNav: " ",
  currentNav: " ",
  telNo: " ",
  mobileNo: " ",
  email: " ",
};

export const monthdata = [
  "Latest Month",
  "Last 12 Month",
  "Specify Date Range",
];
export const fundbenchmarkTableHead = [
  <LeftArrow fillColor="#ffffff" />,
  "Fund Benchmark",
  " ",
];
export const fundbenchmarkTableData = [
  { arrow: "", benchmarkplan: "Mi-Plan IP Global Macro Fund in USD" },
  { arrow: "", benchmarkplan: "JSE Top 40 in USD" },
  { arrow: "", benchmarkplan: "S&P 500" },
  { arrow: "", benchmarkplan: "Dow Jones Industrial Average" },
  { arrow: "", benchmarkplan: "Gold price in USD" },
];

export const pricingTabelHeader = [
  "Date",
  "Stock Acc.",
  "Bank Acc.",
  "Fee Acc.",
  "Total",
  "Units",
  "HWM",
  "Man. fees",
  "Perf. fees",
  "Compliance fees",
  "Audit fees",
  "IFA fee",
  "Nav",
  "",
];

export const pricingTableData = [
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    StockAcc: "$1,000,000.00",
    BankAcc: "$1,000.00",
    FeeAcc: "$ 2,000.80",
    Total: "$995,000.75",
    Units: "1,000,000.8",
    HWM: "$12.11813",
    Manfees: "$1,000.98",
    Perffees: "$1,000.82",
    Compliancefees: "$5.28",
    Auditfees: "$5.28",
    IFAfee: "-$1,200.28",
    Nav: "$99.28",
  },
];

export const dateData = [
  "12 march 2022",
  "13 march 2022",
  "14 march 2022",
  "15 march 2022",
  "16 march 2022",
];
export const fundData = [
  {
    title: "VAT Applicable?:",
  },
  {
    title: "Fund Name:",
  },
  {
    title: "Fund Philosophy:",
  },
  {
    title: "Pricing Inputs:",
  },
  {
    title: "Inception Date:",
  },
  {
    title: "Unit Starting Price(R):",
  },
  {
    title: "Management Fee(%):",
  },
  {
    title: "Performance Fee(%):",
  },
  {
    title: "Pro Rata Audit Fee(R p.a.):",
  },
  {
    title: "Select Currency (R/ $):",
  },
];
export const IFAsTableHead = [
  "WCM IFA no",
  "Name",
  "Surname",
  "Phone Number",
  "Email",
  "AUM",
];
export const IFAsTableData = [
  {
    id: 1,
    wcmIfaNo: "IFA001",
    name: "Drago Mijatović",
    surname: "Mijatović",
    phone: "083 819 6231",
    email: "DragoMijatovic@rhyta.com",
    aum: "R 55,750.03",
  },
  {
    id: 2,
    wcmIfaNo: "IFA002",
    name: "Rato Barić",
    surname: "Barić",
    phone: "083 819 6231",
    email: "RatoBaric@armyspy.com",
    aum: "R 55,750.03",
  },
  {
    id: 3,
    wcmIfaNo: "IFA003",
    name: "Vid Tadić",
    surname: "Tadić",
    phone: "083 819 6231",
    email: "VidTadic@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 4,
    wcmIfaNo: "IFA004",
    name: "Romana Ivanec",
    surname: "Ivanec",
    phone: "083 819 6231",
    email: "RomanaIvanec@xv.com",
    aum: "R 55,750.03",
  },
  {
    id: 5,
    wcmIfaNo: "IFA005",
    name: "Milka Čeh",
    surname: "Čeh",
    phone: "083 819 6231",
    email: "MilkaCeh@jourrapide.com",
    aum: "R 55,750.03",
  },
  {
    id: 6,
    wcmIfaNo: "IFA006",
    name: "Zrinko Brkić",
    surname: "Brkić",
    phone: "083 819 6231",
    email: "ZrinkoBrkic@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 7,
    wcmIfaNo: "IFA007",
    name: "Kristian Milić",
    surname: "Milić",
    phone: "083 819 6231",
    email: "KristianMilic@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 8,
    wcmIfaNo: "IFA008",
    name: "Smiljana Brajković",
    surname: "Brajković",
    phone: "083 819 6231",
    email: "DSmiljanaBraj@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 9,
    wcmIfaNo: "IFA009",
    name: "Dario Herceg",
    surname: "Herceg",
    phone: "083 819 6231",
    email: "DarioHerceg@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 10,
    wcmIfaNo: "IFA010",
    name: "Zorislav Jurišić",
    surname: "Jurišić",
    phone: "083 819 6231",
    email: "ZorislavJurisic@xv.com",
    aum: "R 55,750.03",
  },
  {
    id: 11,
    wcmIfaNo: "IFA011",
    name: "Kristian Milić",
    surname: "Milić",
    phone: "083 819 6231",
    email: "KristianMilic@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 12,
    wcmIfaNo: "IFA012",
    name: "Smiljana Brajković",
    surname: "Brajković",
    phone: "083 819 6231",
    email: "DSmiljanaBraj@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 13,
    wcmIfaNo: "IFA013",
    name: "Dario Herceg",
    surname: "Herceg",
    phone: "083 819 6231",
    email: "DarioHerceg@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 14,
    wcmIfaNo: "IFA014",
    name: "Milka Čeh",
    surname: " Čeh",
    phone: "083 819 6231",
    email: "MilkaCeh@jourrapide.com",

    aum: "R 55,750.03",
  },
  {
    id: 15,
    wcmIfaNo: "IFA015",
    name: "Zrinko Brkić",
    surname: "Brkić",
    phone: "083 819 6231",
    email: "ZrinkoBrkic@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 16,
    wcmIfaNo: "IFA016",
    name: "Kristian Milić",
    surname: "Milić",
    phone: "083 819 6231",
    email: "KristianMilic@dayrep.com",
    aum: "R 55,750.03",
  },
  {
    id: 17,
    wcmIfaNo: "IFA017",
    name: "Smiljana Brajković",
    surname: "Brajković",
    phone: "083 819 6231",
    email: "DSmiljanaBraj@dayrep.com",
    aum: "R 55,750.03",
  },
];

export const taxFreeInvestmentTableHead = [
  "Name",
  "Code",
  "Volume",
  "Cost Price",
  "Current Price",
  "% Change",
  "Current Value",
  "% of Portfolio",
];

export const taxFreeInvestmentTableData = [
  {
    name: "Coreshares Prop trust",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Coreshares Prop trust",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Coreshares Prop trust",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Coreshares Prop trust",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Coreshares Prop trust",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Coreshares Prop trust",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
  {
    name: "Coreshares Prop trust",
    code: "CSPROP",
    volume: "5000",
    costPrice: "R 9.65",
    currentPrice: "R 11.15",
    change: "14.13%",
    currentValue: "R 55,750.03",
    ofPortfolio: "18.95%",
  },
];

export const taxFreeInvestmentTableData2 = [
  {
    name: "",
    code: "",
    volume: "",
    costPrice: "",
    currentPrice: "",
    change: "Cash",
    currentValue: "R 1,869.23",
    ofPortfolio: "2.3%",
  },
  {
    name: "Total Portfolio Value Open",
    // code: "",
    volume: "255,739.29",
    // costPrice: "",
    // currentPrice: "",
    change: "Total Portfolio value Now",
    currentValue: "R 310,123.99",
    ofPortfolio: "100%",
  },
];

export const snapshotGraphData = [
  {
    name: "SA Equity (PPM)",
    a: 3950,
    R: "R6,1m",
    uv: "1003",
    pv: "2000",
  },
  {
    name: "TFSA (PPM)",
    b: 3500,
    R: "R2,5m",
    uv: "2002",
    pv: "3304",
  },
  {
    name: "Allan Gray Equity",
    c: 3900,
    R: "R15,4m",
    uv: "2541",
    pv: "1667",
  },
];

export const statisticsTableMainHeader1 = [
  {
    title: "Bignning NAV",
    value: "0.00",
  },
  {
    title: "Deposites withdrawals",
    value: "39,341.57",
  },
  {
    title: "Ending NAV",
    value: "39,657.43",
  },
];

export const statisticsGraphData = [
  {
    name: "Page A",
    uv: 4000,
    pv: 2400,
    amt: 2400,
  },
  {
    name: "Page B",
    uv: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    name: "Page C",
    uv: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    name: "Page D",
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: "Page E",
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
];

export const statisticsTableHeader1 = ["Top Performers", "Value", "CTR"];
export const statisticsTableData1 = [
  {
    performer: "VXX 220211C000",
    value: "0.00",
    ctr: "1.84",
  },
  {
    performer: "VXX 220211C000",
    value: "0.00",
    ctr: "0.91",
  },
  {
    performer: "VXX 220211C000",
    value: "0.00",
    ctr: "0.31",
  },
];

export const statisticsTableMainHeader2 = [
  {
    title: "max Drawdown",
    value: "0.26%",
  },
  {
    title: "Peak-to-Valley",
    value: "Jan2022-Feb2022",
  },
  {
    title: "Sharp-Ratio",
    value: "1.59",
  },
  {
    title: "Standard Daviation",
    value: "0.57%",
  },
];

export const statisticsTableHeader2 = ["Bottom Performers", "Value", "CTR"];

export const statisticsTableData2 = [
  {
    performer: "BITO 220211C000",
    value: "0.00",
    ctr: "-0.70",
  },
  {
    performer: "VXX 220211C000",
    value: "-430.06",
    ctr: "-0.47",
  },
  {
    performer: "BITO 220211C000",
    value: "0.00",
    ctr: "-0.38",
  },
  {
    performer: "VXX 220211C000",
    value: "-754.78",
    ctr: "-0.35",
  },
  {
    performer: "VXX 220211C000",
    value: "-404.52",
    ctr: "-0.21",
  },
];

export const allocationTableHeader1 = [
  {
    cash: "Finatial Inst.",
    long: "Long",
    per: "(%)",
  },
];
export const allocationTableHeader2 = [
  {
    cash: "Asset Class",
    long: "Long",
    per: "(%)",
  },
];

export const allocationTableRow1Data = [
  {
    cash: "Cash",
    long: "412416.79",
    per: "100.00",
  },
];

export const allocationTableRow2Data = [
  {
    cash: "Total",
    long: "412416.79",
    per: "100.00",
  },
];

export const allocationTableRow3Data = [
  {
    cash: "Options",
    long: "-1,583.36",
    per: "100.00",
  },
];

export const allocationTableRow4Data = [
  {
    cash: "Total",
    long: "-1,583.36",
    per: "100.00",
  },
];

export const allocationTableRow5Data = [
  {
    cash: "Equities",
    long: "-1,583.36",
    per: "100.00",
  },
];
export const activeDeactivateFundHead = ["Fund", "Status", ""];
export const activeDeactiveFundData = [
  {
    id: 1,
    fund: "Rock Capital Top 20 Fund LLP",
    status: "Inactive",
    reverse: "Activate",
  },
  {
    id: 2,
    fund: "Make a Million Investment Club",
    status: "Active",
    reverse: "Inactive",
  },
  {
    id: 3,
    fund: "Rock Capital Top 20 Mock Fund",
    status: "Inactive",
    reverse: "Activate",
  },
  {
    id: 4,
    fund: "Rock Capital Top 20 Fund LLP",
    status: "Inactive",
    reverse: "Activate",
  },
  {
    id: 5,
    fund: "Make a Million Investment Club",
    status: "Active",
    reverse: "Deactivate",
  },
  {
    id: 6,
    fund: "Rock Capital Top 20 Mock Fund",
    status: "Active",
    reverse: "Deactivate",
  },
  {
    id: 7,
    fund: "Rock Capital Top 20 Fund LLP",
    status: "Active",
    reverse: "Deactivate",
  },
  {
    id: 8,
    fund: "Make a Million Investment Club",
    status: "Inactive",
    reverse: "Activate",
  },
  {
    id: 9,
    fund: "Rock Capital Top 20 Mock Fund",
    status: "Active",
    reverse: "Deactivate",
  },
];
export const clientDetailsTableHeader = [
  "Funds",
  "Nov 2019",
  "Dec 2019",
  "Jan 2020",
  "Feb 2020",
  "Mar 2020",
  "Apr 2020",
  "May 2020",
  "Jun 2020",
  "Jul 2020",
  "Aug 2020",
  "Sep 2020",
  "Oct 2020",
  "YTD",
];

export const clientDetailsTableDta = [
  {
    Funds: "Walt Cap.",
    Nov2019: "-",
    Dec2019: "-",
    Jan2020: "-",
    Feb2020: 0.0,
    Mar2020: 0.7,
    Apr2020: 4.8,
    May2020: 7.1,
    Jun2020: 4.8,
    jul2020: 8.9,
    Aug2020: 1.0,
    Sep2020: -1.4,
    Oct2020: "-",
    YTD: 28.25,
  },
  {
    Funds: "S&P500",
    Nov2019: "-",
    Dec2019: "-",
    Jan2020: "-",
    Feb2020: -4.8,
    Mar2020: -14,
    Apr2020: 11.6,
    May2020: 7.3,
    Jun2020: -1.2,
    jul2020: 8.7,
    Aug2020: 7.2,
    Sep2020: -4.1,
    Oct2020: "-",
    YTD: 4.09,
  },
];

export const fileList = [
  "10001",
  "100023",
  "100045",
  "100093",
  "2 jan 2022.CSV",
  "5 jan 2022.CSV",
  "10 jan 2022.CSV",
];

export const banchmarksTableHead = [
  "",
  "6 months",
  "1 Year",
  "Year to date",
  "Since inception",
];

export const banchmarksTable = [
  // {
  //   name: "",
  //   // monts: "6 months",
  //   year: "1 year",
  //   yearDate: "Year to date ",
  //   inception: "Since inception",
  // },
  {
    name: "Fund",
    months: "0.00%",
    year: "0.00%",
    yearDate: "0.00%",
    inception: "0.00%",
  },
  {
    name: "AL SI",
    months: "14.22%",
    year: "14.22%",
    yearDate: "14.22%",
    inception: "14.22%",
  },
  // {
  //   name: "AL SI",
  //   monts: "14.22%",
  //   year: "14.22%",
  //   yearDate: "14.22%",
  //   inception: "14.22%",
  // },
];

export const riskStatistics = [
  {
    name: "Standard Deviation",
    value: "0.00%",
  },
  {
    name: "Best Month",
    value: "NA",
  },
  {
    name: "Worst month",
    value: "NA",
  },
  {
    name: "Max Drawdown",
    value: "NA",
  },
  {
    name: "% of positive months",
    value: "0",
  },
  {
    name: " % of negative months",
    value: "0",
  },
];

export const reportsDropdownData = [
  {
    title: "AUM Summary",
    navigate: "reports/aum-summary",
  },
  {
    title: "Run fees PPM",
    navigate: "reports/runfeesppm",
  },
  {
    title: "Run fees for Trade Station",
    navigate: "reports/runfees-tradestation",
  },
  {
    title: "Run fees for IB",
    navigate: "reports/runfees-ib",
  },
  {
    title: " Month End Fees Template",
    navigate: "reports/monthendfees-template",
  },
  {
    title: "Portfolio Manager Fee",
    navigate: "reports/portfoliomanagerfee",
  },
  {
    title: "IFA Fees Report",
    navigate: "reports/ifafeesreport",
  },
  {
    title: "PPM Client List",
    navigate: "reports/ppm-client-list",
  },
  {
    title: "PPM Client List TFSA",
    navigate: "reports/ppm-client-list-tfsa",
  },
  {
    title: "Allen Gray Client List",
    navigate: "reports/allan-gray-client-list",
  },
  {
    title: "Tradestation Client List",
    navigate: "reports/trade-station-client-list",
  },
  {
    title: "Interactive Brokers Client List",
    navigate: "reports/interactive-brokers-client-list",
  },
];
export const maintenanceDropdownData = [
  {
    title: "Upload CSV Data Files",
    navigate: "maintenanceportal/upload",
  },
  {
    title: "System Access",
    navigate: "maintenanceportal/system-access",
  },
  {
    title: "Manage User Logins and Passwords",
    navigate: "maintenanceportal/manage-user-login-password",
  },
];

export const incomePPMdata = [
  {
    title: "IFA Trail Fees",
    value: "R  1,500.00",
  },
  {
    title: "Equity Brokerage",
    value: "R  15,125.09",
  },
  {
    title: "JSE Interest Turn",
    value: "R 1,012.63",
  },
  {
    title: "Advisor Custodian Fee",
    value: "R 2,575.00 ",
  },
  {
    title: "Equity management Fees",
    value: "R 15,132.63",
  },
  {
    title: "Equity Performance Fees",
    value: "R 26,998.10",
  },
  {
    title: "TFSA Management Fees",
    value: "R 6,598.78",
  },
];

export const incomBrokersData = [
  {
    title: "IFA Trail Fees",
    value: "$ 1,500.00",
  },
  {
    title: "Equity Brokerage",
    value: "$ 15,125.09",
  },
  {
    title: "Equity management Fees",
    value: "$ 1,012.63",
  },
  {
    title: "Equity Performance Fees",
    value: "$ 2,575.00",
  },
];

export const expensePPMData = [
  {
    title: "Trading System Fees",
    value: "-R 1,500.00",
  },
  {
    title: "Settlement Fees",
    value: "-R 15,125.09",
  },
  {
    title: "Brokerage Per Trade",
    value: "-R 132.50",
  },
  {
    title: "Qty Trades Done",
    value: "156",
  },
  {
    title: "Other Fees",
    value: "-R 1,012.63",
  },
  {
    title: "IFA Trail Fees",
    value: "-R 2,575.00",
  },
];

export const incomeTradeStation = [
  {
    title: "IFA Trail Fees",
    value: "$ 1,500.00",
  },
  {
    title: "Equity management Fees",
    value: "$ 1,012.63",
  },
  {
    title: "Equity Performance Fees",
    value: "$ 2,575.00",
  },
];

export const expenseBrokersData = [
  {
    title: "Other Fees",
    value: "-$  1,500.00",
  },
  {
    title: "IFA Trail Fees",
    value: "-$  1,012.63",
  },
];

export const yearNumber = ["2019", "2020", "2021"];

export const monthNameData = [
  "Jan",
  " Feb",
  "Mar",
  "Apr",
  "May",
  "Jun ",
  "Jul",
  "Aug",
  " Sep ",
  "Oct",
  "Nov",
  "Dec",
];

export const portfolioTableHead = [
  // <LeftArrow fillColor="#ffffff" />,
  "Portfolio Manager",
  "Management fees (local)",
  "Management fees (Offshore)",
  "Performance fees",
  "Pref fees Offshore",
  "Min fees",
  "Total",
  "VAT",
];

export const portfolioManagerFeeTable = [
  {
    symbol: "",
    name: "Betty White",
    localFee: "52.123.25",
    offshoreFee: "1,235.66",
    performanceFee: "65,325.23",
    perfFeesOffshore: "6,523.33",
    minFees: "3550.00",
    total: "128,757.47",
    vat: "15,450.90",
  },
  {
    symbol: "",
    name: "Jon Jones",
    localFee: "52.123.25",
    offshoreFee: "1,235.66",
    performanceFee: "65,325.23",
    perfFeesOffshore: "6,523.33",
    minFees: "3550.00",
    total: "128,757.47",
    vat: "15,450.90",
  },
  {
    symbol: "",
    name: "Kevin Kline",
    localFee: "52.123.25",
    offshoreFee: "1,235.66",
    performanceFee: "65,325.23",
    perfFeesOffshore: "6,523.33",
    minFees: "3550.00",
    total: "128,757.47",
    vat: "15,450.90",
  },
];

export const ppmClientListHeader = [
  "Surname",
  "Name",
  "Account No.",
  "Acc.Value",
  "Currency",
];
export const ppmClientListTableData = [
  {
    surname: "Snow",
    name: "John",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Frank",
    name: "Anne",
    accountNo: "125648",
    accValue: "310,554",
    currency: "ZAR",
  },
  {
    surname: "Soros",
    name: "George",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Peanut",
    name: "Peter",
    accountNo: "125648",
    accValue: "12,548",
    currency: "ZAR",
  },
];
export const ppmClientListSumData = {
  surname: " ",
  name: " ",
  accountNo: "Total Portfolios Value",
  accValue: "310,123.99",
  currency: "ZAR",
};
export const tradestationHeader = [
  "Client Name",
  "Account",
  "Portfolio Value",
  "E mail",
  "Contact Number",
  "Portfolio Manager",
];

export const tradestationTableData = [
  {
    clientName: "Berchtwald Rode",
    acount: "11359645",
    portfolioValue: "13,558.50",
    email: "berchtwald@gmail.com",
    contactNumber: "2352025145",
    portfolioManager: "pierre van dar wlat",
  },
  {
    clientName: "Berchtwald Rode",
    acount: "11359645",
    portfolioValue: "13,558.50",
    email: "berchtwald@gmail.com",
    contactNumber: "2352025145",
    portfolioManager: "pierre van dar wlat",
  },
  {
    clientName: "Berchtwald Rode",
    acount: "11359645",
    portfolioValue: "13,558.50",
    email: "berchtwald@gmail.com",
    contactNumber: "2352025145",
    portfolioManager: "pierre van dar wlat",
  },
  {
    clientName: "Berno Rode",
    acount: "11370347",
    portfolioValue: "70068.99",
    email: "berchtwald@gmail.com",
    contactNumber: "2125326540",
    portfolioManager: "Teddy Beacon",
  },
  {
    clientName: "Chart Huniun",
    acount: "11284129",
    portfolioValue: "152365.97",
    email: "chart2@gmail.com",
    contactNumber: "2195861502",
    portfolioManager: "Bonny Bell",
  },
  {
    clientName: "Chart Huniun",
    acount: "11284129",
    portfolioValue: "152365.97",
    email: "chart2@gmail.com",
    contactNumber: "2195861502",
    portfolioManager: "Bonny Bell",
  },
  {
    clientName: "Chart Huniun",
    acount: "11284129",
    portfolioValue: "152365.97",
    email: "chart2@gmail.com",
    contactNumber: "2195861502",
    portfolioManager: "Bonny Bell",
  },
];

export const interactiveBrokersHeader = [
  "Account No.",
  "Walt Cap No.",
  "Name",
  "Surname",
  "Portfolio Value",
  "Portfolio Manager",
];
export const interactiveBrokersTableData = [
  {
    accountNo: "IB 11234434",
    waltCapNo: "Walt12302",
    name: "Colette",
    surname: "Coetzee",
    portfolioValue: "4,00,123.55",
    portfolioManager: "pierre van der Wlat",
  },
  {
    accountNo: "IB 11234434",
    waltCapNo: "Walt12302",
    name: "Colette",
    surname: "Coetzee",
    portfolioValue: "4,00,123.55",
    portfolioManager: "pierre van der Wlat",
  },
  {
    accountNo: "IB 11234434",
    waltCapNo: "Walt12302",
    name: "Colette",
    surname: "Coetzee",
    portfolioValue: "4,00,123.55",
    portfolioManager: "pierre van der Wlat",
  },
  {
    accountNo: "IB 11234434",
    waltCapNo: "Walt12302",
    name: "Colette",
    surname: "Coetzee",
    portfolioValue: "4,00,123.55",
    portfolioManager: "pierre van der Wlat",
  },
  {
    accountNo: "IB 11234434",
    waltCapNo: "Walt12302",
    name: "Colette",
    surname: "Coetzee",
    portfolioValue: "4,00,123.55",
    portfolioManager: "pierre van der Wlat",
  },
  {
    accountNo: "IB 11234434",
    waltCapNo: "Walt12302",
    name: "Colette",
    surname: "Coetzee",
    portfolioValue: "4,00,123.55",
    portfolioManager: "pierre van der Wlat",
  },
];

export const balanceData = [
  {
    title: "SA Equity (PPM)",
    value: "ZAR: 15,151,559",
    clients: "112",
    percentage: 13,
    navigate: "ppm-model-equity-portfolio",
  },
  {
    title: "SA TFSA (PPM)",
    value: "ZAR: 5,136,003",
    clients: "98",
    percentage: 7,
    navigate: "ppm-tfsa-model-portfolio",
  },
  {
    title: "Allan Gray Equity",
    value: "ZAR: 15,451,559",
    clients: "56",
    percentage: 14,
  },
  {
    title: "Allan Gray (RA)",
    value: "ZAR: 26,121,009",
    clients: "31",
    percentage: 29,
  },
  {
    title: "Allan Gray (LA) ",
    value: "ZAR: 20,951,600",
    clients: "15",
    percentage: 25,
  },
  {
    title: "Allan Gray TFSA",
    value: "ZAR: 3,141,599",
    clients: "231",
    percentage: 9,
  },
  {
    title: "Trade Station....",
    value: "USD: 1,150,901",
    clients: "16",
    percentage: 16,
  },
  {
    title: "Interactive Bro...",
    value: "USD: 250,354",
    clients: "4",
    percentage: 8,
  },
  {
    title: "Walt Capital Gl...",
    value: "USD: 2,250,354 ",
    clients: "18",
    percentage: 26,
    navigate: "walt-capital-global-fund-investor",
  },
];

export const allenGrayClientListHeader = [
  "Clients",
  "Groups",
  "Investment Value",
];

export const allenGrayClientListData = [
  {
    name: "Mrs. Grietje Berrington",
    id: "192011",
    amount: "R  1,00,215.61",
  },
  {
    name: "Mrs. Theresa Theunsina Wilhelmina",
    id: "022158",
    amount: "R  2,90,215.43",
  },
  {
    name: "Mrs. Grietje Berrington",
    id: "022156",
    amount: "R  2,78,791.33",
  },
  {
    name: "Mr. Wiam David Botma",
    id: "022157",
    amount: "R  2,90,215.43",
  },
  {
    name: "Mr. Francois Buitendach",
    id: "646971",
    amount: "R  17,120.28",
  },
];

export const success = {
  id: 1,
  title: "Success",
  description: "Photo successfully uploaded",
  backgroundColor: "#5cb85c",
  icon: <Check />,
};

export const danger = {
  id: 2,
  title: "Danger",
  description: "This is an error toast component",
  backgroundColor: "#d9534f",
  icon: <Error />,
};

export const info = {
  id: 3,
  title: "Info",
  description: "This is an info toast component",
  backgroundColor: "#5bc0de",
  icon: <Info />,
};

export const warning = {
  id: 4,
  title: "Warning",
  description: "This is a warning toast component",
  backgroundColor: "#f0ad4e",
  icon: <Warning />,
};
export const accountSummary = [
  {
    name: "Opening Balance",
    value: "R 1867.50",
    icon: "",
  },
  {
    name: "Performance",
    value: "R 5.91",
    icon: <DropdownIcon2 fillColor="#0F0F0F" width="15px" height="8px" />,
  },
  {
    name: "Closing Balance",
    value: "R 1873.41",
    icon: "",
  },
];

export const AccountSummaryGainGraphData = [
  {
    value: "20 May 2015",
    uv: "R 400000",
    pv: 377784,
    amt: 2400,
  },
  // {
  //   value: "20 May 2015",
  //   uv: 300000,
  //   pv: 300000,
  //   amt: 2400,
  // },
  {
    value: "20 May 2015",
    uv: 413784,
    pv: 412784,
    amt: 2210,
  },
  {
    value: "",
    uv: 433784,
    pv: 400000,
    amt: 2290,
  },
  {
    value: "",
    uv: 452784,
    pv: 452784,
    amt: 2000,
  },
  {
    value: "",
    uv: 462784,
    pv: 432784,
    amt: 2181,
  },
  {
    value: "",
    uv: 482784,
    pv: 472784,
    amt: 2181,
  },
  {
    value: "",
    uv: 501000,
    pv: 500000,
    amt: 2181,
  },
  {
    value: "",
    uv: 511000,
    pv: 401000,
    amt: 2181,
  },
  {
    value: "",
    uv: 541000,
    pv: 400000,
    amt: 2181,
  },
  {
    value: "",
    uv: 561000,
    pv: 560000,
    amt: 2181,
  },
  {
    value: "",
    uv: 603402,
    pv: 603402,
    amt: 2181,
  },
  {
    value: "15 Mar 2022",
    uv: 2323,
    pv: 1212,
    amt: 2435,
  },
];

export const clientData = [
  {
    title: "100452   Mr. John James",
    icon: <Tick fillColor="#0868AA" />,
  },
  {
    title: "100452   Mr. John James",
    icon: <Tick fillColor="#0868AA" />,
  },
  {
    title: "200146  Mrs. Susan Smith	",
    icon: <CloseBlackIcon fillColor="black" />,
  },
  {
    title: "601540  Dr. Emie Short",
    icon: <CloseBlackIcon fillColor="black" />,
  },
  {
    title: "100452   Mr. John James",
    icon: <Tick fillColor="#0868AA" />,
  },
  {
    title: "200146  Mrs. Susan Smith	",
    icon: <Tick fillColor="#0868AA" />,
  },
  {
    title: "601540  Dr. Emie Short",
    icon: <Tick fillColor="#0868AA" />,
  },
];

export const ifaClientListHeader = ["Name", "Surname", "Client ID", "IFA ID"];
export const ifaClientListData = [
  {
    name: "Marissa Van Myk",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
  },
  {
    name: "John",
    surname: "De Beer",
    clientID: 100294,
    ifaID: 3,
  },
  {
    name: "Hono",
    surname: "Pretorious",
    clientID: 100256,
    ifaID: 3,
  },
  {
    name: "Marie-Ann",
    surname: "Anouhilas",
    clientID: 100235,
    ifaID: 3,
  },
];

export const OffshoreClientListTableHead = [
  "Surname",
  "Name",
  "Account No.",
  "Acc. Value",
  "Currency",
  // "Action",
];
export const OffshoreListTableData = [
  {
    surname: "Snow ",
    name: "John",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Frank ",
    name: "Anne",
    accountNo: "125648",
    accValue: "310,554",
    currency: "ZAR",
  },
  {
    surname: "Soros ",
    name: "George",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Peanut ",
    name: "Peter",
    accountNo: "125648",
    accValue: "12,548",
    currency: "ZAR",
  },
  {
    surname: "Snow ",
    name: "John",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Frank ",
    name: "Anne",
    accountNo: "125648",
    accValue: "310,554",
    currency: "ZAR",
  },
  {
    surname: "Soros ",
    name: "George",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Peanut ",
    name: "Peter",
    accountNo: "125648",
    accValue: "12,548",
    currency: "ZAR",
  },
  {
    surname: "Snow ",
    name: "John",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Frank ",
    name: "Anne",
    accountNo: "125648",
    accValue: "310,554",
    currency: "ZAR",
  },
  {
    surname: "Soros ",
    name: "George",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Peanut ",
    name: "Peter",
    accountNo: "125648",
    accValue: "12,548",
    currency: "ZAR",
  },
  {
    surname: "Snow ",
    name: "John",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Frank ",
    name: "Anne",
    accountNo: "125648",
    accValue: "310,554",
    currency: "ZAR",
  },
  {
    surname: "Soros ",
    name: "George",
    accountNo: "115489",
    accValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Peanut ",
    name: "Peter",
    accountNo: "125648",
    accValue: "12,548",
    currency: "ZAR",
  },
];

export const clientTransactionTabelHeader = [
  "Date",
  "Bank",
  "Futures",
  "Stock",
  "Total",
  "Units",
  "HWM",
  "GAV",
  "Audit",
  "Management",
  "Performance",
  "Fee run",
  "IFA Run",
  "Nav",
  "",
];

export const clientTransactionTableData = [
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
  {
    date: "2022-10-20",
    bank: "0",
    futures: "0",
    stock: "247,939.82",
    total: "R 247,939.82",
    units: "247,543.4",
    hwm: "R 11,118.13",
    gav: "R 0,97463",
    audit: "R 0",
    management: "R 9.24",
    performance: "R 0",
    feeRun: "R 0",
    ifaRun: "R 0",
    nav: "R 0,97,45,897",
    edit: "Edit",
  },
];
export const modelEquityTableHeader = [
  "Name",
  "Code",
  "Volume",
  "Cost Price",
  "Current Price",
  "% Change",
  "Current Value",
  "% of Portfolio",
];

export const modelEquityTableBody = [
  {
    name: "Coreshares Prop trust",
    code: "CSPROP",
    volume: "5,000",
    cost: "R 9.65",
    current: "R 11.15",
    change: "14.13%",
    value: "R 55,750.03",
    portfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "SYG4IR",
    volume: "1,000",
    cost: "R 50.20",
    current: "R 41.55",
    change: "-19.6%",
    value: "R 41,550.00",
    portfolio: "16.52%",
  },
  {
    name: "Coreshares Prop trust ",
    code: "CSPROP",
    volume: "1,000",
    cost: "R 9.65",
    current: "R 11.15",
    change: "14.13%",
    value: "R 55,750.03",
    portfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "SYG4IR",
    volume: "5,000",
    cost: "R 50.20",
    current: "R 41.55",
    change: "-19.6%",
    value: "R 41,550.00",
    portfolio: "16.52%",
  },
  {
    name: "Coreshares Prop trust",
    code: "CSPROP",
    volume: "1,000",
    cost: "R 9.65",
    current: "R 11.15",
    change: "14.13%",
    value: "R 55,750.03",
    portfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "SYG4IR",
    volume: "5,000",
    cost: "R 50.20",
    current: "R 41.55",
    change: "-19.6%",
    value: "R 41,550.00",
    portfolio: "16.52%",
  },
  {
    name: "Coreshares Prop trust ",
    code: "CSPROP",
    volume: "1,000",
    cost: "R 9.65",
    current: "R 11.15",
    change: "14.13%",
    value: "R 55,750.03",
    portfolio: "18.95%",
  },
  {
    name: "Sygnia 4th Rev ETF",
    code: "SYG4IR",
    volume: "5,000",
    cost: "R 50.20",
    current: "R 41.55",
    change: "-19.6%",
    value: "R 41,550.00",
    portfolio: "16.52%",
  },
];

export const modelEquityPortfolioCash = {
  name: "",
  code: "",
  volume: "",
  cost: "",
  current: "",
  change: "Cash",
  value: "R 1,869.23",
  portfolio: "2.3%",
};

export const saEquityHead = [
  "Account No.",
  "Name",
  "Email",
  "Phone Number",
  "Birthday",
  "Join Date",
  "Investment Value",
];
export const saEquityBody = [
  {
    accNo: "115489",
    name: "Drago Mijatović",
    email: "DragoMijatovic@rhyta.com",
    telNO: "083 819 6231",
    birthday: "January 19, 2001",
    joindate: "02/05/2020",
    investmentValue: "R 308851.50",
  },
  {
    accNo: "458462",
    name: "Rato Barić",
    email: "RatoBaric@armyspy.com",
    telNO: "083 819 6231",
    birthday: "May 1, 1970",
    joindate: "06/12/2021",
    investmentValue: "R 10841.50",
  },
  {
    accNo: "265484",
    name: "Vid Tadić",
    email: "VidTadic@dayrep.com",
    telNO: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "06/08/2015",
    investmentValue: "R 567851.50",
  },
  {
    accNo: "236548",
    name: "Romana Ivanec",
    email: "RomanaIvanec@xv.com",
    telNO: "083 819 6231",
    birthday: "May 29, 1988",
    joindate: "06/08/2015",
    investmentValue: "R -258854",
  },
  {
    accNo: "123548",
    name: "Milka Čeh",
    email: "MilkaCeh@jourrapide.com",
    telNO: "083 819 6231",
    birthday: "March 26, 1943",
    joindate: "02/01/2020",
    investmentValue: "R 108487.36",
  },
  {
    accNo: "115489",
    name: "Drago Mijatović",
    email: "DragoMijatovic@rhyta.com",
    telNO: "083 819 6231",
    birthday: "January 19, 2001",
    joindate: "02/05/2020",
    investmentValue: "R 308851.50",
  },
  {
    accNo: "458462",
    name: "Rato Barić",
    email: "RatoBaric@armyspy.com",
    telNO: "083 819 6231",
    birthday: "May 1, 1970",
    joindate: "06/12/2021",
    investmentValue: "R 10841.50",
  },
  {
    accNo: "265484",
    name: "Vid Tadić",
    email: "VidTadic@dayrep.com",
    telNO: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "06/08/2015",
    investmentValue: "R 567851.50",
  },
  {
    accNo: "236548",
    name: "Romana Ivanec",
    email: "RomanaIvanec@xv.com",
    telNO: "083 819 6231",
    birthday: "May 29, 1988",
    joindate: "06/08/2015",
    investmentValue: "R -258854",
  },
  {
    accNo: "123548",
    name: "Milka Čeh",
    email: "MilkaCeh@jourrapide.com",
    telNO: "083 819 6231",
    birthday: "March 26, 1943",
    joindate: "02/01/2020",
    investmentValue: "R 108487.36",
  },
  {
    accNo: "115489",
    name: "Drago Mijatović",
    email: "DragoMijatovic@rhyta.com",
    telNO: "083 819 6231",
    birthday: "January 19, 2001",
    joindate: "02/05/2020",
    investmentValue: "R 308851.50",
  },
  {
    accNo: "458462",
    name: "Rato Barić",
    email: "RatoBaric@armyspy.com",
    telNO: "083 819 6231",
    birthday: "May 1, 1970",
    joindate: "06/12/2021",
    investmentValue: "R 10841.50",
  },
  {
    accNo: "265484",
    name: "Vid Tadić",
    email: "VidTadic@dayrep.com",
    telNO: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "06/08/2015",
    investmentValue: "R 567851.50",
  },
  {
    accNo: "236548",
    name: "Romana Ivanec",
    email: "RomanaIvanec@xv.com",
    telNO: "083 819 6231",
    birthday: "May 29, 1988",
    joindate: "06/08/2015",
    investmentValue: "R -258854",
  },
  {
    accNo: "123548",
    name: "Milka Čeh",
    email: "MilkaCeh@jourrapide.com",
    telNO: "083 819 6231",
    birthday: "March 26, 1943",
    joindate: "02/01/2020",
    investmentValue: "R 108487.36",
  },
  {
    accNo: "115489",
    name: "Drago Mijatović",
    email: "DragoMijatovic@rhyta.com",
    telNO: "083 819 6231",
    birthday: "January 19, 2001",
    joindate: "02/05/2020",
    investmentValue: "R 308851.50",
  },
  {
    accNo: "458462",
    name: "Rato Barić",
    email: "RatoBaric@armyspy.com",
    telNO: "083 819 6231",
    birthday: "May 1, 1970",
    joindate: "06/12/2021",
    investmentValue: "R 10841.50",
  },
  {
    accNo: "265484",
    name: "Vid Tadić",
    email: "VidTadic@dayrep.com",
    telNO: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "06/08/2015",
    investmentValue: "R 567851.50",
  },
  {
    accNo: "236548",
    name: "Romana Ivanec",
    email: "RomanaIvanec@xv.com",
    telNO: "083 819 6231",
    birthday: "May 29, 1988",
    joindate: "06/08/2015",
    investmentValue: "R -258854",
  },
  {
    accNo: "123548",
    name: "Milka Čeh",
    email: "MilkaCeh@jourrapide.com",
    telNO: "083 819 6231",
    birthday: "March 26, 1943",
    joindate: "02/01/2020",
    investmentValue: "R 108487.36",
    // name: "Drago Mijatović",
    // email: "DragoMijatovic@rhyta.com",
    // telNO: "083 819 6231",
    // birthday: "January 19, 2001",
    // joindate: "02/05/2020",
    // investmentValue: "R 308851.50",
  },
  {
    accNo: "458462",
    name: "Rato Barić",
    email: "RatoBaric@armyspy.com",
    telNO: "083 819 6231",
    birthday: "May 1, 1970",
    joindate: "06/12/2021",
    investmentValue: "R 10841.50",
  },
  {
    accNo: "265484",
    name: "Vid Tadić",
    email: "VidTadic@dayrep.com",
    telNO: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "06/08/2015",
    investmentValue: "R 567851.50",
  },
  {
    accNo: "236548",
    name: "Romana Ivanec",
    email: "RomanaIvanec@xv.com",
    telNO: "083 819 6231",
    birthday: "May 29, 1988",
    joindate: "06/08/2015",
    investmentValue: "R -258854",
  },
  {
    accNo: "123548",
    name: "Milka Čeh",
    email: "MilkaCeh@jourrapide.com",
    telNO: "083 819 6231",
    birthday: "March 26, 1943",
    joindate: "02/01/2020",
    investmentValue: "R 108487.36",
  },
  {
    accNo: "115489",
    name: "Drago Mijatović",
    email: "DragoMijatovic@rhyta.com",
    telNO: "083 819 6231",
    birthday: "January 19, 2001",
    joindate: "02/05/2020",
    investmentValue: "R 308851.50",
  },
  {
    accNo: "458462",
    name: "Rato Barić",
    email: "RatoBaric@armyspy.com",
    telNO: "083 819 6231",
    birthday: "May 1, 1970",
    joindate: "06/12/2021",
    investmentValue: "R 10841.50",
  },
  {
    accNo: "265484",
    name: "Vid Tadić",
    email: "VidTadic@dayrep.com",
    telNO: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "06/08/2015",
    investmentValue: "R 567851.50",
  },
  {
    accNo: "236548",
    name: "Romana Ivanec",
    email: "RomanaIvanec@xv.com",
    telNO: "083 819 6231",
    birthday: "May 29, 1988",
    joindate: "06/08/2015",
    investmentValue: "R -258854",
  },
  {
    accNo: "123548",
    name: "Milka Čeh",
    email: "MilkaCeh@jourrapide.com",
    telNO: "083 819 6231",
    birthday: "March 26, 1943",
    joindate: "02/01/2020",
    investmentValue: "R 108487.36",
  },
  {
    accNo: "115489",
    name: "Drago Mijatović",
    email: "DragoMijatovic@rhyta.com",
    telNO: "083 819 6231",
    birthday: "January 19, 2001",
    joindate: "02/05/2020",
    investmentValue: "R 308851.50",
  },
  {
    accNo: "458462",
    name: "Rato Barić",
    email: "RatoBaric@armyspy.com",
    telNO: "083 819 6231",
    birthday: "May 1, 1970",
    joindate: "06/12/2021",
    investmentValue: "R 10841.50",
  },
  {
    accNo: "265484",
    name: "Vid Tadić",
    email: "VidTadic@dayrep.com",
    telNO: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "06/08/2015",
    investmentValue: "R 567851.50",
  },
  {
    accNo: "236548",
    name: "Romana Ivanec",
    email: "RomanaIvanec@xv.com",
    telNO: "083 819 6231",
    birthday: "May 29, 1988",
    joindate: "06/08/2015",
    investmentValue: "R -258854",
  },
  {
    accNo: "123548",
    name: "Milka Čeh",
    email: "MilkaCeh@jourrapide.com",
    telNO: "083 819 6231",
    birthday: "March 26, 1943",
    joindate: "02/01/2020",
    investmentValue: "R 108487.36",
  },
  {
    accNo: "115489",
    name: "Drago Mijatović",
    email: "DragoMijatovic@rhyta.com",
    telNO: "083 819 6231",
    birthday: "January 19, 2001",
    joindate: "02/05/2020",
    investmentValue: "R 308851.50",
  },
  {
    accNo: "458462",
    name: "Rato Barić",
    email: "RatoBaric@armyspy.com",
    telNO: "083 819 6231",
    birthday: "May 1, 1970",
    joindate: "06/12/2021",
    investmentValue: "R 10841.50",
  },
  {
    accNo: "265484",
    name: "Vid Tadić",
    email: "VidTadic@dayrep.com",
    telNO: "083 819 6231",
    birthday: "May 5, 1948",
    joindate: "06/08/2015",
    investmentValue: "R 567851.50",
  },
  {
    accNo: "236548",
    name: "Romana Ivanec",
    email: "RomanaIvanec@xv.com",
    telNO: "083 819 6231",
    birthday: "May 29, 1988",
    joindate: "06/08/2015",
    investmentValue: "R -258854",
  },
  {
    accNo: "123548",
    name: "Milka Čeh",
    email: "MilkaCeh@jourrapide.com",
    telNO: "083 819 6231",
    birthday: "March 26, 1943",
    joindate: "02/01/2020",
    investmentValue: "R 108487.36",
  },
];
export const modelEquityPortfolioFooter = {
  name: "Total Portfolio Value Open",
  code: "",
  volume: "255,739.29",
  cost: "",
  current: "Total Portfolio value Now",
  change: "",
  value: "R 310,123.99",
  portfolio: "100%",
};

export const JSETaxFreeAccountHeader = [
  "Surname",
  "Name",
  "Account No.",
  "Acc. Value",
  "Currency",
  "Action",
];

export const JSETaxFreeAccountData = [
  {
    surname: "Snow",
    name: "John",
    accountNumber: "115489",
    accountValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Frank",
    name: "Anne",
    accountNumber: "125648",
    accountValue: "12,548",
    currency: "ZAR",
  },
  {
    surname: "Soros",
    name: "George",
    accountNumber: "115489",
    accountValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Peanut",
    name: "Peter",
    accountNumber: "125648",
    accountValue: "12,548",
    currency: "ZAR",
  },
  {
    surname: "Frank",
    name: "Anne",
    accountNumber: "125648",
    accountValue: "12,548",
    currency: "ZAR",
  },
  {
    surname: "Soros",
    name: "George",
    accountNumber: "115489",
    accountValue: "2,315,255",
    currency: "ZAR",
  },
  {
    surname: "Peanut",
    name: "Peter",
    accountNumber: "125648",
    accountValue: "12,548",
    currency: "ZAR",
  },
];
export const waltCapitalClientTableHead = [
  "Name",
  "Title",
  "Acc. No.",
  "Units",
  "Value",
  "Cost NAV",
  "Current NAV",
  "Tel. No.",
  "Mobile No.",
  "Email",
];
export const waltCapitalClientTableData = [
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
  {
    name: "Snow, John",
    title: "Mr.",
    acount_no: "100001",
    units: "1,453,333.1",
    value: "$18,514,425",
    cost_nav: "$10.5902",
    current_nav: "$18.6503",
    tel: "0212014556",
    mobile_no: "0824541234",
    email: "john@snow.com",
  },
];
export const aumSummaryHeader = [
  "Product",
  "Fund Currency",
  "Value (Fund Currency)",
];

export const aumSummaryTable = [
  {
    product: "Living Annuity",
    fundCurrency: "ZAR",
    valueFundCurrency: " R 23 918 897.30",
  },
  {
    product: "Retirement Annuity Fund",
    fundCurrency: "ZAR",
    valueFundCurrency: " R 23 918 897.30",
  },
  {
    product: "Investment Platform Unit Trust",
    fundCurrency: "ZAR",
    valueFundCurrency: " R 308851.50",
  },
  {
    product: "Pension Preservation Fund",
    fundCurrency: "ZAR",
    valueFundCurrency: " R 23 918 897.30",
  },
  {
    product: "Tax-Free Investment",
    fundCurrency: "ZAR",
    valueFundCurrency: " R 23 918 897.30",
  },
  {
    product: "Allen Gray Unit Trust",
    fundCurrency: "ZAR",
    valueFundCurrency: " R 308851.50",
  },
  {
    product: "Total",
    fundCurrency: "ZAR",
    valueFundCurrency: " R 308851.50",
  },
  {
    product: "Offshore",
    fundCurrency: "USD",
    valueFundCurrency: " $ 308851.50",
  },
];
export const attentionTableHead = [
  "Fee Type",
  "Client",
  "Fund",
  "Date",
  "Amount (excl VAT)",
  "Amount(incl VAT)",
];
export const attentionTableData = [
  {
    total: "Total (excl VAT)",
    value: "R 0.00",
  },
  {
    total: "VAT @ 14% payable by Rock Capital",
    value: "R 0.00",
  },
  {
    total: "Total (incl VAT)",
    value: "R 0.00",
  },
];
export const attentionTableContent = [
  {
    attention_fees: " ",
    client: " ",
    fund: " ",
    date: " ",
    amount_excl: " ",
    amount_incl: " ",
  },
  {
    attention_fees: " ",
    client: " ",
    fund: " ",
    date: " ",
    amount_excl: " ",
    amount_incl: " ",
  },
  {
    attention_fees: " ",
    client: " ",
    fund: " ",
    date: " ",
    amount_excl: " ",
    amount_incl: " ",
  },
  {
    attention_fees: " ",
    client: " ",
    fund: " ",
    date: " ",
    amount_excl: " ",
    amount_incl: " ",
  },
  {
    attention_fees: " ",
    client: " ",
    fund: " ",
    date: " ",
    amount_excl: " ",
    amount_incl: " ",
  },
  {
    attention_fees: " ",
    client: " ",
    fund: " ",
    date: " ",
    amount_excl: " ",
    amount_incl: " ",
  },
  {
    attention_fees: " ",
    client: " ",
    fund: " ",
    date: " ",
    amount_excl: " ",
    amount_incl: " ",
  },
  {
    attention_fees: " ",
    client: " ",
    fund: " ",
    date: " ",
    amount_excl: " ",
    amount_incl: " ",
  },
];

export const monthlyReportsHeader = [
  "Name",
  "Surname",
  "Client ID",
  "IFA ID",
  "Trans Value",
  "Units",
  "Date",
  "Upfront fee",
  "Annual fee",
  "Fund",
];

export const monthlyReportsdata = [
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
  {
    name: "Marissa",
    surname: "-",
    clientID: 100254,
    ifaID: 3,
    transValue: -527002,
    units: -166250.55,
    date: 2014 - 10 - 22,
    upfrontFee: "1% ",
    annualFee: "1%",
    fund: "Rock Capital top 20 Eauity",
  },
];

export const runfeesTotalData = {
  fees: "",
  lastrundate: "Total fee run :",
  lastaum: "$10,078,23",
  nextrundate: "",
  action: "",
  pendingamount: "",
  totol: "",
  vat: "",
  totalvat: "",
};

export const ifaBreakDownHead = [
  // <LeftArrow fillColor="#ffffff" />,
  "",
  "Name",
  "Surname",
  "Tel No.",
  "Email",
  "IFA ID",
  "AUM",
  "ZAR Fee",
  "VAT",
  "Total ZAR Fee",
  "USD Fee",
];

export const ifaBreakDownBody = [
  {
    arrow: "",
    name: "Liza-Marie",
    surname: "Vendor Supply",
    tel: "021 456 1988",
    email: "liza@rbtech.com",
    ifa: "IFA001",
    aum: "R 158,365.00",
    zar: "R 410.00",
    vat: "R 118.77",
    total: "R 910.00",
    usd: "$ 216.99",
  },
  {
    arrow: "",
    name: "Jay",
    surname: "Silver",
    tel: "021 456 1988",
    email: "jj@memo.com",
    ifa: "IFA002",
    aum: "R 954,002.55",
    zar: "R 4,152.02",
    vat: "R 724.22",
    total: "R 5,495.51",
    usd: "$ 217.99",
  },
  {
    arrow: "",
    name: "Liza",
    surname: "Vendor",
    tel: "021 456 1988",
    email: "liza@rvth.com",
    ifa: "IFA003",
    aum: "R 1,220,556.00",
    zar: "R 7,568.25",
    vat: "R 915.25",
    total: "R 7,415.23",
    usd: "$ 218.99",
  },
];
export const dailyTradeLogTableHead = [
  "Trade Done",
  "In market",
  "Name",
  "Code",
  "Quantity",
  "Price",
  "Acc. No.",
  "Trade No.",
  "Fees",
  "Comment",
];

export const dailyTradeLogTableData = [
  {
    name: "Wynand Bloemhof",
    code: "TGA",
    quntity: 1000,
    price: "145.00",
    accountNumber: 112233,
    tradeNumber: 63,
    fee: "R 725.00",
    comment: "Keep order in GTC and...",
    // comment: "Keep order in GTC and...",
  },
  {
    name: "Wynand Bloemhof",
    code: "TGA",
    quntity: 1000,
    price: "145.00",
    accountNumber: 112233,
    tradeNumber: 63,
    fee: "R 725.00",
    comment: "Keep order in GTC and...",
    // comment: "Keep order in GTC and...",
  },
  {
    name: "Wynand Bloemhof",
    code: "TGA",
    quntity: 1000,
    price: "145.00",
    accountNumber: 112233,
    tradeNumber: 63,
    fee: "R 725.00",
    comment: "Keep order in GTC and...",
  },
];

export const offshoreClientListTableFooter = {
  surname: "",
  name: "",
  accNo: "Total Portfolios Value",
  accVal: "310,123.99",
  currency: "ZAR",
};
export const modelPortfolioHead = ["", "Portfolio", "S&P 500"];
export const modelPortfolioTableData = [
  {
    duration: "Since Inception(1 Feb 2020)",
    portfolio: "52.11%",
    percentage: "45.44%",
  },
  {
    duration: "Latest Year(12 Months)",
    portfolio: "8.75%",
    percentage: "15.65%",
  },
  {
    duration: "Latest 6 Months(180 Days)",
    portfolio: "9.72%",
    percentage: "5.92%",
  },
  {
    duration: "Latest 3 Months(90 Days)",
    portfolio: "6.40%",
    percentage: "-4.60%",
  },
  {
    duration: "Latest Months(30 Days)",
    portfolio: "2.22%",
    percentage: "3.71%",
  },
  {
    duration: "Year to Date",
    portfolio: "6.40%",
    percentage: "-4.60%",
  },
  {
    duration: "Annualised+",
    portfolio: "21.38%",
    percentage: "18.89%",
  },
];

export const riskStatisticTableData = [
  {
    duration: "Standard Deviation",
    portfolio: "17.03%",
    percentage: "20.83%",
  },
  {
    duration: "Best Months",
    portfolio: "8.9%",
    percentage: "12.08%",
  },
  {
    duration: "Worst Month",
    portfolio: "-5.8%",
    percentage: "-12.4%",
  },
  {
    duration: "Max Draw down",
    portfolio: "18.5%",
    percentage: "19.6%",
  },
  {
    duration: "% of Positive Months",
    portfolio: "65.4%",
    percentage: "65.4%",
  },
  {
    duration: "% of Negative Months",
    portfolio: "34.6%",
    percentage: "34.6%",
  },
];

export const topHoldingsTableData = [
  {
    typeOfMoney: "Stock",
    percentage: "20%",
  },
  {
    typeOfMoney: "Silver",
    percentage: "30%",
  },
  {
    typeOfMoney: "Bitcoin",
    percentage: "10%",
  },
  {
    typeOfMoney: "Cash",
    percentage: "40%",
  },
];

export const monthlyPerformanceHead = [
  // "Year",
  "",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "YTD",
];

export const monthlyPerformanceTable = [
  {
    // year: "2020",
    // emp: "",
    type: "Portfolio",
    jan: "",
    feb: 0.0,
    mar: 0.7,
    apr: 4.8,
    may: 7.8,
    jun: 4.8,
    jul: 8.9,
    aug: "1.0",
    sep: -1.4,
    oct: 3.7,
    nov: 6.1,
    dec: 8.3,
    YTD: 52.8,
  },
  {
    // year: "",
    // emp: "",
    type: "S&P 500",
    jan: "",
    feb: -8.2,
    mar: -12.4,
    apr: 12.8,
    may: 4.8,
    jun: "2.0",
    jul: 5.6,
    aug: 7.2,
    sep: -3.8,
    oct: -2.7,
    nov: 10.9,
    dec: 3.8,
    YTD: 18.45,
  },
  {
    // year: "2021",
    // emp: "",
    type: "Portfolio",
    jan: -0.3,
    feb: -2.8,
    mar: -5.6,
    apr: 5.9,
    may: 4.1,
    jun: -0.4,
    jul: -5.8,
    aug: -4.3,
    sep: 0.2,
    oct: 3.1,
    nov: -4.2,
    dec: 4.4,
    YTD: -6.45,
  },
  {
    // year: "",
    // emp: "",
    type: "S&P 500",
    jan: "-1.0",
    feb: 2.8,
    mar: 4.4,
    apr: 5.3,
    may: 0.7,
    jun: 2.3,
    jul: 2.4,
    aug: "3.0",
    sep: -4.7,
    oct: "7.0",
    nov: -0.7,
    dec: 4.5,
    YTD: 28.71,
  },
  {
    // year: "2022",
    // emp: "",
    type: "Portfolio",
    jan: -3.9,
    feb: 8.3,
    mar: 2.2,
    apr: "",
    may: "",
    jun: "",
    jul: "",
    aug: "",
    sep: "",
    oct: "",
    nov: "",
    dec: "",
    YTD: 6.4,
  },
  {
    // year: "",
    // emp: "",
    type: "S&P 500",
    jan: -5.2,
    feb: "-3.0",
    mar: 3.7,
    apr: "",
    may: "",
    jun: "",
    jul: "",
    aug: "",
    sep: "",
    oct: "",
    nov: "",
    dec: "",
    YTD: "-4.60",
  },
];

// export const dattaaaaa = {
//   year: "2020",
//   emp: "",
// };

export const portfolioPerformanceGraphData = [
  {
    value: "Feb20",
    uv: 4000,
    pv: 2400,
    amt: 2400,
    yAxis: "R1.25",
  },
  {
    value: "Mar",
    uv: 3000,
    pv: 1398,
    amt: 2210,
    yAxis: "R1.25",
  },
  {
    value: "Apr20",
    uv: 2000,
    pv: 8800,
    amt: 2290,
    yAxis: "R1.25",
  },
  {
    value: "May20",
    uv: 2780,
    pv: 3908,
    amt: 2000,
    yAxis: "R1.25",
  },
  {
    value: "Jun20",
    uv: 1890,
    pv: 4800,
    amt: 2181,
    yAxis: "R1.25",
  },
  {
    value: "Jul20",
    uv: 2390,
    pv: 3800,
    amt: 2500,
    yAxis: "R1.25",
  },
  {
    value: "Aug20",
    uv: 2780,
    pv: 3908,
    amt: 2100,
    yAxis: "R1.25",
  },
  {
    value: "Sep20",
    uv: 3323,
    pv: 4300,
    amt: 2435,
    yAxis: "R1.25",
  },
  {
    value: "Oct20",
    uv: 2390,
    pv: 3800,
    amt: 2435,
    yAxis: "R1.25",
  },
  {
    value: "Nov20",
    uv: 1890,
    pv: 4800,
    amt: 2435,
    yAxis: "R1.25",
  },
  {
    value: "Dec20",
    uv: 2323,
    pv: 1212,
    amt: 2435,
    yAxis: "R1.25",
  },
  {
    value: "Jan21",
    uv: 2780,
    pv: 3908,
    amt: 2435,
    yAxis: "R1.25",
  },
  {
    value: "Feb21",
    uv: 2323,
    pv: 1212,
    amt: 2435,
    yAxis: "R1.25",
  },
  {
    value: "Mar21",
    uv: 3323,
    pv: 4300,
    amt: 2435,
    yAxis: "R1.25",
  },
  {
    value: "Apr21",
    uv: 2323,
    pv: 1212,
    amt: 2435,
    yAxis: "R1.25",
  },
];

export const IFAFeeReportHead = [
  "Name",
  "Surname",
  "Tel No.",
  "Email",
  "IFA ID",
  "AUM",
  "ZAR Fee",
  "VAT",
  "Total ZAR Fee",
  "USD Fee",
];

export const IFAFeeReportTableData = [
  {
    name: "Liza-Marie",
    surname: "Vendor",
    telNo: "021 456 1988",
    email: "liza@rbtech.com",
    ifaId: "IFA001",
    aum: "R 158,365.00",
    ZARFee: "R 410.00",
    VAT: "R 118.77",
    totalZARFee: "R 910.00",
    USDFee: "$ 216.99",
  },
  {
    name: "Jay",
    surname: "Silver",
    telNo: "021 456 1988",
    email: "jj@memo.com",
    ifaId: "IFA002",
    aum: "R 954,002.55",
    ZARFee: "R 4,152.02",
    VAT: "R 724.22",
    totalZARFee: "R 5,495.51",
    USDFee: "$ 217.99",
  },
  {
    name: "Liza",
    surname: "Vendor",
    telNo: "021 456 1988",
    email: "liza@rvth.com",
    ifaId: "IFA003",
    aum: "R 1,220,556.00",
    ZARFee: "R 7,568.25",
    VAT: "R 915.25",
    totalZARFee: "R 7,415.23",
    USDFee: "$ 218.99",
  },
];

export const runFeesPPMHead = [
  "Name",
  "Surname",
  "Acc No.",
  "End Value",
  "1.2% fee ex.vat",
  "VAT",
  "Total",
  "Admin fee",
  "VAT",
  "Total",
  "IFA Fee",
  "Vat",
  "Total",
];

export const runFeesPPMTableData = [
  {
    name: "Berrington",
    surname: "Fred ",
    accNo: "111690",
    endValue: "214,270.16",
    feeEx: "214.28",
    VAT: "32.14",
    total: "264.42",
    adminFee: "R 50.00",
    VAT2: "R 118.77",
    total2: "264.42",
    ifaFee: "0",
    vat3: "0",
    total3: "0",
  },
  {
    name: "Berrington",
    surname: "Rie ",
    accNo: "111666",
    endValue: "214,270.16",
    feeEx: "273.90",
    VAT: "41.05",
    total: "314.74",
    adminFee: "R 50.00",
    VAT2: "R 724.22",
    total2: "314.74",
    ifaFee: "0",
    vat3: "0",
    total3: "0",
  },
  {
    name: "Berrington",
    surname: "Wyand",
    accNo: "113365",
    endValue: "214,270.16",
    feeEx: "120.38",
    VAT: "18.06",
    total: "138.44",
    adminFee: "R 50.00",
    VAT2: "R 915.25",
    total2: "138.44",
    ifaFee: "0",
    vat3: "0",
    total3: "0",
  },
  {
    name: "Botes",
    surname: "CC",
    accNo: "113449",
    endValue: "114,642.53",
    feeEx: "114.14",
    VAT: "17.20",
    total: "131.84",
    adminFee: "R 50.00",
    VAT2: "R 724.22",
    total2: "314.74",
    ifaFee: "0",
    vat3: "0",
    total3: "0",
  },
  {
    name: "Botes",
    surname: "TA",
    accNo: "113431",
    endValue: "115,692.48",
    feeEx: "115.69",
    VAT: "17.35",
    total: "133.85",
    adminFee: "R 50.00",
    VAT2: "R 915.25",
    total2: "138.44",
    ifaFee: "0",
    vat3: "0",
    total3: "0",
  },
  {
    name: "",
    surname: "",
    accNo: "Total",
    endValue: "873,145.49",
    feeEx: "838.18",
    VAT: "125.08",
    total: "965.29",
    adminFee: "R 250.00",
    VAT2: "R 3,397.71",
    total2: "R 1,152.78",
    ifaFee: "-",
    vat3: "-",
    total3: "-",
  },
];

export const runFeesPPMEquityHead = [
  "1% & 5% Performance fee only",
  "Acc No.",
  "Start",
  "Withdrawal / Dep1",
  "Withdrawal / Dep2",
  "End Value",
  "P & L",
  "1.2% fee ex vat",
  "15% fee ex vat",
  "Total fee ex vat",
  "15% vat",
  "Total Inc vat",
  "Nuwe Wimerk",
  "Admin fee",
  "VAT",
  "Total",
  "IFA Fee",
  "Vat",
  "Total",
];

export const runFeesPPMEquityData = [
  {
    perFee: "Rie Berrington",
    accNo: "111690",
    start: "R 717,517.73",
    dep1: "R-",
    dep2: "R-",
    endValue: "R 801,497.55",
    pl: "R 43,979.82",
    exVAT: "R 801.50",
    exVAT2: "R 6596.97",
    totalVAT: "R 7398.47",
    exVAT3: "R 1109.74",
    totalIncVat: "R 8508.24",
    nuweWimerk: "R 792,989.31",
    adminFee: "R 50.00",
    vat: "R 7.50",
    total: "R 57.50",
    ifaFee: "0",
    vat2: "0",
    total2: "0",
  },
  {
    perFee: "Bloemhof Wynand",
    accNo: "113373",
    start: "R 844,253.17",
    dep1: "R-",
    dep2: "R-",
    endValue: "R 946,933.31",
    pl: "R 102,680.14",
    exVAT: "R 946.93",
    exVAT2: "-",
    totalVAT: "R 946.93",
    exVAT3: "R 142.04",
    totalIncVat: "R 1088.94",
    nuweWimerk: "R 945,844.34",
    adminFee: "R 50.00",
    vat: "R 7.50",
    total: "R 57.50",
    ifaFee: "0",
    vat2: "0",
    total2: "0",
  },
  {
    perFee: "Belinda de Swardt",
    accNo: "125690",
    start: "R 34,138.71",
    dep1: "R-",
    dep2: "R-",
    endValue: "R 26,250.35",
    pl: "-",
    exVAT: "R 26.25",
    exVAT2: "-",
    totalVAT: "R 26.25",
    exVAT3: "R 3.94",
    totalIncVat: "R 30.19",
    nuweWimerk: "R 34,108.52",
    adminFee: "R 50.00",
    vat: "R 7.50",
    total: "R 57.50",
    ifaFee: "0",
    vat2: "0",
    total2: "0",
  },
  {
    perFee: "Hattingh Rico",
    accNo: "140905",
    start: "R 33,468.95",
    dep1: "R-",
    dep2: "R-",
    endValue: "R 32,927.14",
    pl: "-",
    exVAT: "R 32.93",
    exVAT2: "-",
    totalVAT: "R 32.93",
    exVAT3: "R 4.94",
    totalIncVat: "R 37.87",
    nuweWimerk: "R 33,431.09",
    adminFee: "R 50.00",
    vat: "R 7.50",
    total: "R 57.50",
    ifaFee: "0",
    vat2: "0",
    total2: "0",
  },
  {
    perFee: "Mark Lockwood",
    accNo: "155440",
    start: "R 202,124.33",
    dep1: "-R  600,000.00",
    dep2: "-R",
    endValue: "R 206,741.83",
    pl: "R 4,617.50",
    exVAT: "-",
    exVAT2: "R 8586.15",
    totalVAT: "-",
    exVAT3: "-",
    totalIncVat: "-",
    nuweWimerk: "#######",
    adminFee: "R 50.00",
    adminFee: "R 7.50",
    total: "R 57.50",
    ifaFee: "0",
    vat2: "0",
    total2: "0",
  },
];

export const runFeesPPMEquityDataTwo = [
  {
    perFee: "",
    accNo: "",
    start: "Fees ex vat",
    dep1: "",
    dep2: "Total",
    endValue: "R 20,14,350.18",
    pl: "R 1,51,277.46",
    exVAT: "R 1,807.61",
    exVAT2: "R 15,807.61",
    totalVAT: "R 854.54",
    exVAT3: "R 1261.85",
    totalIncVat: "R 9570.52",
    nuweWimerk: "",
    adminFee: "R 250.00",
    adminFee: "R 37.50",
    total: "R 287.50",
    ifaFee: "-",
    vat2: "-",
    total2: "-",
  },
  {
    perFee: "Total Fees",
    accNo: "1.2%",
    start: "R 3,920.28",
    dep1: "",
    dep2: "",
    endValue: "",
    pl: "",
    exVAT: "",
  },
  {
    perFee: "",
    accNo: "15%",
    start: "R 22,119.19",
    dep1: "",
    dep2: "",
    endValue: "",
    pl: "",
    exVAT: "",
  },
  {
    perFee: "",
    accNo: "",
    start: "R 26,039.47",
    dep1: "",
    dep2: "",
    endValue: "",
    pl: "",
    exVAT: "",
  },
];

export const runTradeStationHeadData = [
  "1% & 5% perfromence fees only",
  "Acc",
  "Start",
  "ont / dep 1",
  "ont / dep 2",
  "End Value",
  "P&L",
  "1.2% fee ex Vat",
  "15% fee ex Vat",
  "Total fee ex Vat",
  " ",
  "Total Incl Vat",
  "nuwe w/merk",
  "IFA fee",
  "Vat",
  "Total",
];
export const tradeStationClientHeadData = [
  "1% & 5% perfromence fees only",
  "Acc",
  "Start",
  "ont / dep 1",
  "ont / dep 2",
  "End Value",
  "P&L",
  "1.2% fee ex Vat",
  "15% fee ex Vat",
  "Total fee ex Vat",
  " ",
  "Total Incl Vat",
  "new high w/mark",
  "IFA fee",
  "Vat",
  "Total",
];
export const runTradeStationTableData = [
  {
    name: "Linda de Swardth",
    accNo: "11157953",
    start: "$70,331.38",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$70,174.00",
    p_and_l: "$0.00",
    fee_ex_vat: "$70.17",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$70.17",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$70.17",
    nuwe_w_merk: "$70,261.21",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
  {
    name: "Judy Botha",
    accNo: "11127070",
    start: "$72,795.10",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$71,768.00",
    p_and_l: "$0.00",
    fee_ex_vat: "$71.77",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$71.77",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$71.77",
    nuwe_w_merk: "$72,723.33",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
  {
    name: "Hennie Stoltz",
    accNo: "11157306",
    start: "$35,460.75",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$35,368.00",
    p_and_l: "$0.00",
    fee_ex_vat: "$35.37",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$35.37",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$35.37",
    nuwe_w_merk: "$35,425.38",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
  {
    name: "Joe Diab",
    accNo: "11157583",
    start: "$70,331.38",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$18,871.43",
    p_and_l: "$0.00",
    fee_ex_vat: "$0.00",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$0.00",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$0.00",
    nuwe_w_merk: "$18,871.43",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
  {
    name: "Wouter Van Vlaanderen",
    accNo: "11158313",
    start: "$11,664.55",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$11,004.00",
    p_and_l: "$0.00",
    fee_ex_vat: "$11.00",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$11.00",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$11.0",
    nuwe_w_merk: "$11,653.55",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
  {
    name: "Tina Stoltz",
    accNo: "11173405",
    start: "$21,005.08",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$20,674.00",
    p_and_l: "$0.00",
    fee_ex_vat: "$20.67",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$20.67",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$20.67",
    nuwe_w_merk: "$20,984.41",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
  {
    name: "Micheal Halstead",
    accNo: "11173641",
    start: "$54,963.06",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$54,823.00",
    p_and_l: "$0.00",
    fee_ex_vat: "$54.82",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$54.82",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$54.82",
    nuwe_w_merk: "$54,908.24",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
];

export const tradeStationTableSumData = [
  {
    name1: "",
    accNo1: "",
    start1: "",
    on_dep1_1: " ",
    on_dep2_1: " ",
    end_value1: "$425,869.00",
    p_and_l_1: "Total",
    fee_ex_vat1_1: "$425.87",
    fifteen_fee_ex_vat1: "$0.00",
    total_fee_ex_vat1: "$425.87",
    fee_ex_vat1_1: "$0.00",
    total_incl_vat1: "$425.87",
    nuwe_w_merk1: "$0.00",
    ifa_fee1: "-",
    vat1: "-",
    total1: "-",
  },
  {
    name1: "Total Fees",
    accNo1: "12%",
    start1: "$425.87",
    on_dep1_1: " ",
    on_dep2_1: " ",
    end_value1: " ",
    p_and_l_1: " ",
    fee_ex_vat1: " ",
    fifteen_fee_ex_vat1: " ",
    total_fee_ex_vat1: " ",
    total_incl_vat1: " ",
    nuwe_w_merk1: "",
    ifa_fee1: "",
    vat1: "",
    total1: "",
  },
  {
    name1: "",
    accNo1: " 15%",
    start1: "$0.00",
    on_dep1_1: " ",
    on_dep2_1: " ",
    end_value_1: " ",
    p_and_l_1: " ",
    fee_ex_vat1: " ",
    fifteen_fee_ex_vat1: " ",
    total_fee_ex_vat1: " ",
    total_incl_vat1: " ",
    nuwe_w_merk1: "",
    ifa_fee1: "",
    vat1: "",
    total1: "",
  },
  {
    name1: "",
    accNo1: " ",
    start1: "$425.87",
    on_dep1_1: " ",
    on_dep2_1: " ",
    end_value1: " ",
    p_and_l_1: " ",
    fee_ex_vat1: " ",
    fifteen_fee_ex_vat1: " ",
    total_fee_ex_vat1: " ",
    total_incl_vat1: " ",
    nuwe_w_merk1: "",
    ifa_fee1: "",
    vat1: "",
    total1: "",
  },
];
export const tradeStationClientData = [
  {
    name: "Linda de Swardth",
    surname: "Guiden",
    accNo: "11157953",
    start: "$113.799.83",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$114,025.00",
    p_and_l: "$225,17.00",
    fee_ex_vat: "$70.17",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$70.17",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$70.17",
    new_high_w_mark: "$113,877.20",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
  {
    name: "Judy Botha",
    surname: "Augutyn",
    accNo: "11127070",
    start: "$35,774.95",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$35,774.95",
    p_and_l: "$0.00",
    fee_ex_vat: "$71.17",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$71.17",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$71.17",
    new_high_w_mark: "$35,739.38",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
  {
    name: "Hennie Stoltz",
    surname: "Athols",
    accNo: "11157306",
    start: "$484,579.00",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$485,155.00",
    p_and_l: "$576.00",
    fee_ex_vat: "$35.37",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$35.37",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$35.17",
    new_high_w_mark: "$484,583.45",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
  {
    name: "Joe Diab",
    surname: "Mark",
    accNo: "11157583",
    start: "$7537.82",
    on_dep1: "$0.00",
    on_dep2: "$0.00",
    end_value: "$7,354.00",
    p_and_l: "$0.00",
    fee_ex_vat: "$0.00",
    fifteen_fee_ex_vat: "$0.00",
    total_fee_ex_vat: "$0.00",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$00.00",
    new_high_w_mark: "$7,530.47",
    ifa_fee: 0,
    vat: 0,
    total: 0,
  },
];
export const tradeStationClientSumData = [
  {
    name: "",
    accNo: "",
    start: "",
    on_dep1: " ",
    on_dep2: " ",
    end_value: "$1392,385.89",
    p_and_l: "Total",
    fee_ex_vat: "$1392.39",
    fifteen_fee_ex_vat: "$120.18",
    total_fee_ex_vat: "$1512.57",
    fee_ex_vat1: "$0.00",
    total_incl_vat: "$0.00",
    new_high_w_mark: "$0.00",
    ifa_fee: "-",
    vat: "-",
    total: "-",
  },
  {
    name: "Total Fees",
    accNo: "12%",
    start: "$1392.39",
    on_dep1: " ",
    on_dep2: " ",
    end_value: " ",
    p_and_l: " ",
    fee_ex_vat: " ",
    fifteen_fee_ex_vat: " ",
    total_fee_ex_vat: " ",
    fee_ex_vat1: "",
    total_incl_vat: " ",
    new_high_w_mark: "",
    ifa_fee: "",
    vat: "",
    total: "",
  },
  {
    name: "",
    accNo: " 15%",
    start: "$0.00",
    on_dep1: " ",
    on_dep2: " ",
    end_value: " ",
    p_and_l: " ",
    fee_ex_vat: " ",
    fifteen_fee_ex_vat: " ",
    total_fee_ex_vat: " ",
    fee_ex_vat1: "",
    total_incl_vat: " ",
    new_high_w_mark: "",
    ifa_fee: "",
    vat: "",
    total: "",
  },
  {
    name: "",
    accNo: " ",
    start: "$425.87",
    on_dep1: " ",
    on_dep2: " ",
    end_value: " ",
    p_and_l: " ",
    fee_ex_vat: " ",
    fifteen_fee_ex_vat: " ",
    total_fee_ex_vat: " ",
    fee_ex_vat1: "",
    total_incl_vat: " ",
    new_high_w_mark: "",
    ifa_fee: "",
    vat: "",
    total: "",
  },
];

export const manageuserloginpasswordHeaderData = [
  "Users",
  "Login",
  "Dashboard",
  "WatchLists",
  "Clients",
  "Fund Administration",
  "CRM",
  "IFA's",
  "Offshore",
  "Reports",
  "Maintenance Portal",
  "Logout",
];
export const manageuserloginpasswordTableData = [
  {
    users: "Super User",
    login: true,
    dashboard: false,
    watchLists: false,
    clients: false,
    fund_administration: false,
    crm: false,
    ifas: false,
    offshore: false,
    reports: false,
    maintenance_portal: true,
    logout: true,
  },
  {
    users: "Executive User",
    login: false,
    dashboard: true,
    watchLists: true,
    clients: true,
    fund_administration: false,
    crm: false,
    ifas: false,
    offshore: false,
    reports: false,
    maintenance_portal: true,
    logout: true,
  },
  {
    users: "Compliance user",
    login: false,
    dashboard: false,
    watchLists: false,
    clients: false,
    fund_administration: true,
    crm: false,
    ifas: false,
    offshore: false,
    reports: false,
    maintenance_portal: true,
    logout: true,
  },
  {
    users: "Admin User",
    login: false,
    dashboard: false,
    watchLists: false,
    clients: false,
    fund_administration: false,
    crm: true,
    ifas: false,
    offshore: true,
    reports: true,
    maintenance_portal: false,
    logout: true,
  },
  {
    users: "Portfolio Manager",
    login: false,
    dashboard: false,
    watchLists: false,
    clients: false,
    fund_administration: false,
    crm: false,
    ifas: true,
    offshore: false,
    reports: false,
    maintenance_portal: false,
    logout: true,
  },
  {
    users: "Client User",
    login: false,
    dashboard: true,
    watchLists: true,
    clients: true,
    fund_administration: true,
    crm: true,
    ifas: true,
    offshore: true,
    reports: true,
    maintenance_portal: true,
    logout: true,
  },
];

export const tradingHead = ["Bid", "Spread", "Ask", "Day Range"];
export const tradingBody = [
  {
    bid: "14.49686",
    spread: "40.4",
    ask: "14.50090",
  },
];
export const tradingPortalData = [
  {
    label: "Type",
    component: <Swipper title="Limit" />,
  },
  {
    label: "Buy / Sell",
    component: <Swipper title="Buy" />,
  },
  {
    label: "USD",
    component: <Counter count="10,000" />,
  },
  {
    label: "Price",
    component: <Counter count="14.49970 " />,
  },
  {
    label: "Duration",
    component: <Swipper title="One Week" />,
  },
];
export const costData = [
  {
    title: "Cost",
    // icon:false,
    cost: "43.49 ZAR",
  },
  {
    title: "Initial Margin available",
    // icon:true,
    cost: "0.00 USD",
  },
  {
    title: "Initial Margin impact",
    // icon:true,
    cost: "650.00 USD",
  },
  {
    title: "Maintenance margin impact",
    // icon:true,
    cost: "650.00 USD",
  },
];
